var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarLogOutLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150",
      fill: "#010b6c"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M121.76,22.24H28.24c-3.31,0-6,2.69-6,6v93.52c0,3.31,2.69,6,6,6h93.52c3.31,0,6-2.69,6-6V28.24 C127.76,24.93,125.07,22.24,121.76,22.24z M42.29,99.29V48.9h4.73v0.58h-1.88l0.26,49.8H42.29z M66.77,105.63l-19.75-7.12V51.49 l19.75-7.12V105.63z M85.82,99.29h-2.98V52.4H68.59v-3.5h17.23V99.29z M102.65,86.98l-0.13-7.64L91.9,79.47v-9.84h10.75v-7.51 L118.07,75L102.65,86.98z M63.97,76.9c0.52,0,0.95-0.42,0.95-0.95c0-0.52-0.42-0.95-0.95-0.95s-0.95,0.42-0.95,0.95 C63.02,76.47,63.44,76.9,63.97,76.9z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarLogOutLine);
export default __webpack_public_path__ + "static/media/SidebarLogOutLine.c43eb246d56e255409d75de30de4c5c1.svg";
export { ForwardRef as ReactComponent };